(() => {
  if (window.HoyostarDiscountConfetti) return;

  const COLORS = [
    '#ef4aa8', '#6faed9', '#f7c948', '#7b4fd6', '#39c7a5',
    '#ff7a45', '#e84a5f', '#66d9ef', '#8fd14f', '#ffffff'
  ];

  const STATE = {
    lastTarget: null,
    lastLaunchAt: 0,
    activeFrame: null
  };

  const random = (min, max) => Math.random() * (max - min) + min;
  const isMobile = () => window.innerWidth < 750;

  const createCanvas = () => {
    let canvas = document.querySelector('[data-discount-confetti-canvas]');
    if (canvas) return canvas;

    canvas = document.createElement('canvas');
    canvas.setAttribute('data-discount-confetti-canvas', '');

    Object.assign(canvas.style, {
      position: 'fixed',
      inset: '0',
      width: '100vw',
      height: '100vh',
      pointerEvents: 'none',
      zIndex: '999999'
    });

    document.body.appendChild(canvas);
    return canvas;
  };

  const resizeCanvas = (canvas) => {
    const dpr = window.devicePixelRatio || 1;

    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;

    const ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    return ctx;
  };

  const shouldThrottle = (target) => {
    const now = performance.now();

    if (STATE.lastTarget === target && now - STATE.lastLaunchAt < 900) {
      return true;
    }

    STATE.lastTarget = target;
    STATE.lastLaunchAt = now;
    return false;
  };

  const createParticles = (originX, originY, count, burst = 1, mobile = false) => {
    const particles = [];

    for (let i = 0; i < count; i += 1) {
      const angle = random(
        mobile ? -118 : -155,
        mobile ? -62 : -25
      ) * Math.PI / 180;

      const speed = random(
        mobile ? 3.8 : 5.5,
        mobile ? 7.2 : 12
      ) * burst;

      particles.push({
        x: originX + random(mobile ? -3 : -6, mobile ? 3 : 6),
        y: originY + random(mobile ? -3 : -4, mobile ? 3 : 4),
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        gravity: random(mobile ? 0.1 : 0.12, mobile ? 0.2 : 0.26),
        drag: random(0.972, 0.99),
        width: random(mobile ? 2.5 : 3, mobile ? 5 : 7),
        height: random(mobile ? 6 : 8, mobile ? 12 : 16),
        rotation: random(0, Math.PI * 2),
        rotationSpeed: random(-0.32, 0.32),
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        alpha: 1,
        life: random(0.76, 1),
        shape: Math.random() > 0.68 ? 'circle' : 'rect'
      });
    }

    return particles;
  };

  const launch = (target, options = {}) => {
    if (!target) return;
    if (!(target instanceof Element)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (shouldThrottle(target)) return;

    const rect = target.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return;

    const mobile = isMobile();

    const canvas = createCanvas();
    const ctx = resizeCanvas(canvas);

    const originX = mobile
      ? Math.min(Math.max(rect.left + rect.width * 0.5, 42), window.innerWidth - 42)
      : rect.left + rect.width * 0.5;

    const originY = rect.top + rect.height * (mobile ? 0.42 : 0.5);

    const duration = options.duration || (mobile ? 1050 : 1350);

    let particles = mobile
      ? [
          ...createParticles(originX, originY, options.count || 34, 0.82, true),
          ...createParticles(originX, originY, 10, 0.62, true)
        ]
      : [
          ...createParticles(originX, originY, options.count || 64, 1, false),
          ...createParticles(originX, originY, 22, 0.72, false)
        ];

    const start = performance.now();
    let secondBurstAdded = false;

    if (STATE.activeFrame) {
      cancelAnimationFrame(STATE.activeFrame);
      STATE.activeFrame = null;
    }

    const draw = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);

      if (!secondBurstAdded && elapsed > (mobile ? 140 : 180)) {
        particles = particles.concat(
          createParticles(
            originX + random(mobile ? -8 : -18, mobile ? 8 : 18),
            originY + random(mobile ? -5 : -10, mobile ? 5 : 10),
            mobile ? 10 : 24,
            mobile ? 0.58 : 0.82,
            mobile
          )
        );
        secondBurstAdded = true;
      }

      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

      particles.forEach((p) => {
        p.vx *= p.drag;
        p.vy = p.vy * p.drag + p.gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.rotationSpeed;

        p.alpha = Math.max(0, 1 - Math.pow(progress / p.life, 2));

        ctx.save();
        ctx.globalAlpha = p.alpha;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;

        if (p.shape === 'circle') {
          ctx.beginPath();
          ctx.arc(0, 0, p.width * 0.75, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.width / 2, -p.height / 2, p.width, p.height);
        }

        ctx.restore();
      });

      if (progress < 1) {
        STATE.activeFrame = requestAnimationFrame(draw);
      } else {
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        STATE.activeFrame = null;
      }
    };

    STATE.activeFrame = requestAnimationFrame(draw);
  };

  window.HoyostarDiscountConfetti = { launch };

  document.addEventListener('discount-progress:unlocked', (event) => {
    const target =
      event.detail?.target ||
      document.querySelector('[data-discount-progress].is-unlocked') ||
      document.querySelector('[data-discount-progress]');

    launch(target);
  });
})();